<div *ngIf="details">
    <!-- [ngStyle]="{'background-image': 'url(' + details + ')'}" -->
    <div class="details-poster">
        <div class="details-shadow2 details-shadow-2"></div>
        <div class="details-shadow-3"></div>
        <img class="w-100 lazyload" appLazyload="{{details.images | getImage:'wallpapers':'original'}}"
            appLazyPlaceholder="h" (error)="'assets/images/placeholders/placeholder_h.png'" />
    </div>

    <!-- Details -->
    <div class="details-info">
        <div class="container-fluid">
            <!-- Info -->
            <div class="row">
                <div class="col-md-12">
                    <img class="on-demand-logo"
                        [src]="details.type == 0 ? 'assets/images/ondemand.png' : 'assets/images/series_white.png'" />
                    <h1 class="details-title display-4 text-style">{{details.title}}</h1>
                    <!-- Line -->
                    <div class="sep-line pb-2"></div>
                    <div [innerHTML]="details | setupSubInfo:lang"></div>

                    <div class="tags-container">
                        <div class="tags-card" *ngFor="let tag of details?.tags">
                            {{tag | translate}}
                        </div>
                    </div>
                </div>

                <div class="col-md-7 details-desc pr-5">
                    <p>{{details.description}}</p>
                </div>

                <div class="col-md-5 details-cast border-left pl-5"
                    *ngIf="cast.directors?.length || cast.actors?.length">
                    <!-- Directors -->
                    <app-cast [title]="'gen_director'" [cast]="cast?.directors" *ngIf="cast?.directors?.length">
                    </app-cast>

                    <!-- Actors -->
                    <app-cast [title]="'gen_actors'" [cast]="cast?.actors" *ngIf="cast?.actors?.length"></app-cast>
                </div>

                <!-- Buttons -->
                <div class="col-md-12 my-3">
                    <button class="button sm-100 mr-2" *ngFor="let button of buttons;let pos = index;"
                        (click)="doAction(button,pos,null)">
                        <i class="pr-1 {{button.icon}}"></i>
                        {{button.title | translate}}
                        <span *ngIf="button.id == 'continue' && details.bookmarkInfo.episodeNumber">{{"S" +
                            details.bookmarkInfo.seasonNumber + "E" + details.bookmarkInfo.episodeNumber}}</span>

                        <div class="bookmark-progress-container" *ngIf="button.id == 'continue'">
                            <mat-progress-bar class="bookmark-progress" [mode]="'determinate'"
                                [value]="button.percentage"></mat-progress-bar>
                        </div>
                    </button>
                </div>

                <!-- Banner -->
                <div class="col-md-6 my-1 mx-auto" id="DETAILS_BANNER"></div>
            </div>
        </div>

        <!-- Ribbons -->
        <div class="mb-5 pb-5" *ngIf="ribbon">
            <app-ribbon [ribbon]="ribbon"></app-ribbon>
        </div>

        <!-- Seasons -->
        <div class="container-fluid mb-5 pb-5" *ngIf="seasons">
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill">
                        <mat-label>{{'gen_seasons' | translate}}</mat-label>
                        <mat-select #selectedSeason [value]="seasons[bookSeason]">
                            <mat-option [value]="season" *ngFor="let season of seasons">{{('gen_season' | translate) + '
                                ' + season.seasonNumber}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Episodes -->
            <div class="row my-3" *ngFor="let episode of selectedSeason.value.episodes">
                <div class="col-md-3 pb-4">
                    <div class="asset-container">
                        <div class="asset-card">
                            <div class="asset-shadow">
                                <div class="asset-button" (click)="doAction(episode?.button,null,episode)">
                                    <button mat-fab>
                                        <i class="{{episode?.button?.icon}}"></i>
                                    </button>
                                    {{episode?.button?.title | translate}}
                                </div>
                            </div>
                            <div class="asset-poster-container">
                                <img class="asset-poster lazyload"
                                    appLazyload="{{episode.images | getImage:'thumbnails':'original'}}"
                                    appLazyPlaceholder="h" (error)="'assets/images/placeholders/placeholder_h.png'" />

                                <div class="asset-bookmark">
                                    <mat-progress-bar [mode]="'determinate'" [value]="episode?.button?.percentage">
                                    </mat-progress-bar>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-6">
                    <h5 class="clr-theme">{{('gen_episode' | translate) + ' ' + episode.episodeNumber}}</h5>
                    <h3>{{episode.title}}</h3>
                    <p>{{episode.description}}</p>
                </div>
            </div>
        </div>
    </div>
</div>